import { trackMove } from '../../_common/client/tracking';

export const trackNavigationEvent = (labelValue: 'button' | 'image' | 'headline' | 'variation') => {
    trackMove({ product_Navigation: labelValue });
};
